const abTest = (window as any).bdABTest;
import sdk from '@/sdk';

// AB测试 SDK初始化
if (abTest) {
    abTest.init({
        appID: process.env.REACT_APP_AB_TEST_APPID || 'gabY6T2295SJID16YIL', // 请在.env.prod中制定正式appID
        sk: process.env.REACT_APP_AB_TEST_SK || 'W4NSB8IIHI1R2E07RE46BR0PR1CDOLPU', // 请在.env.prod中制定正式sk
    });
}

function getABTestInfoStorage() {
    const storage = localStorage.getItem('bdABTestInfo');
    try {
        return storage ? JSON.parse(storage) : {};
    } catch (e) {
        return {};
    }
}

// AB结果本地缓存
const abTestInfoStorage = getABTestInfoStorage();
const abTestInfo: any = {};
const abTestDefault: any = {
    homepage: 'new', // 首页默认值为新版
};
const abTestTimeout = 200; // 超时时间，单位毫秒

// 上报AB埋点
export function abTestLogger(key: string, event: string, eventAttr: any = {}) {
    if (!abTest || abTestInfo[key]?.disable) {
        return;
    }
    const sid = abTestInfo[key]?.sid || abTestInfoStorage[key]?.sid;
    if (!sid) {
        return;
    }
    abTest.collectEvent({
        ssid: sdk.as.user?.userGuid,
        event: event, // 事件名称
        eventAttr: eventAttr,
        sidList: [sid], // 抽样sid
        version: '1.0.0',
        success: () => {
            // 埋点上报成功回调
        },
    });
}

// 按Key禁用某个实验相关埋点，禁用后此实验将不再上报，不影响其他实验
export function disableABTestLogByKey(key: string) {
    abTestInfo[key] = {...abTestInfo[key], disable: true};
}

// AB获取抽样
export function abTestSampling(ssid?: string) {
    return new Promise((resolve, reject) => {
        if (!abTest) {
            reject(new Error('bdABTest SDK is undefined.'));
            return;
        }
        // 兜底：抽样请求超时限制
        setTimeout(() => {
            if (Object.keys(abTestInfo).length) {
                resolve(abTestInfo);
            } else {
                console.log('bdABTest 获取抽样--超时了----------------------');
                reject(new Error('bdABTest 获取抽样--超时了----------'));
                // resolve(null);
            }
        }, abTestTimeout);
        // 抽样成功回调
        const onSamplingSuccess = (rs: any) => {
            let result;
            try {
                result = JSON.parse(rs);
            } catch (e) {
                result = {};
            }
            const data = result.data || {};
            const info = data.info || [];
            if (info.length) {
                info.forEach((item: any) => {
                    abTestInfo[item.key] = {sid: item.sid, value: item.value};
                });
                localStorage.setItem('bdABTestInfo', JSON.stringify(abTestInfo));
                resolve(abTestInfo);
            } else {
                resolve(null);
            }
        };
        // 获取抽样参数
        abTest.sampling({ssid: ssid, success: onSamplingSuccess});
    });
}

// 兜底：从缓存或默认值获取value
function getStorageValue(key: string) {
    return abTestInfoStorage[key]?.value || abTestDefault[key] || '';
}

// 是否正在请求
let abTestPending: any = null;

// 获取AB测试结果值
export async function getABTestValue(key: string) {
    if (abTestInfo[key]) {
        return abTestInfo[key].value || getStorageValue(key);
    } else {
        const userGuid = sdk.as.user?.userGuid || localStorage.getItem('bdABTestUser') || '';
        try {
            if (!abTestPending) {
                abTestPending = abTestSampling(userGuid);
            }
            const info = await abTestPending;
            if (userGuid) {
                localStorage.setItem('bdABTestUser', userGuid);
            }
            abTestPending = null;
            return info && info[key]?.value ? info[key].value : getStorageValue(key);
        } catch (e) {
            abTestPending = null;
            return getStorageValue(key);
        }
    }
}
